<template>
	<div class="daterange">
		<label v-if="label">{{ label }}{{ req }}</label>
		<div class="fields">
			<Datetime
				v-model="value.from"
				title="Competition start date"
				placeholder="Start date"
				v-bind="{ ...config, ...startRange }"
			/>
			<Datetime
				v-model="value.to"
				title="Competition end date"
				placeholder="End date"
				v-bind="{ ...config, ...endRange }"
			/>
		</div>
	</div>
</template>

<script>
import { Datetime } from 'vue-datetime'
import { DateTime } from 'luxon'
import { toDateTimes } from '@/lib/datetime'

export default {
	name: 'FieldDateRange',
	props: {
		label: String,
		value: {
			type: Object,
			validator: v => 'from' in v && 'to' in v,
		},
		required: Boolean,
		dateOnly: Boolean,
		minDatetime: String,
		maxDatetime: String,
	},
	computed: {
		req() {
			return this.required ? '*' : ''
		},
		startRange() {
			const range = {}
			if (this.minDatetime) {
				range.minDatetime = this.minDatetime
			}
			if (this.maxDatetime || this.value.to) {
				const options = toDateTimes(this.maxDatetime, this.value.to)
				range.maxDatetime = DateTime.min(...options).toISO()
			}
			return range
		},
		endRange() {
			const range = {}
			if (this.minDatetime || this.value.from) {
				const options = toDateTimes(this.minDatetime, this.value.from)
				range.minDatetime = DateTime.max(...options).toISO()
			}
			if (this.maxDatetime) {
				range.maxDatetime = this.maxDatetime
			}
			return range
		},
		config() {
			if (this.dateOnly) {
				return {
					type: 'date',
					format: DateTime.DATE_MED,
				}
			} else {
				return {
					type: 'datetime',
					format: DateTime.DATETIME_MED,
				}
			}
		},
	},
	components: {
		Datetime,
	},
}
</script>

<style lang="scss" scoped>
@import '~vue-datetime/dist/vue-datetime.css';
@import '~scss/layout';
@import '~scss/components';

.daterange {
	label {
		@extend %field-label;
		margin-bottom: 0.75rem;
	}
	.fields {
		@include row;
		::v-deep input {
			@extend %field;
		}
	}

	// Datetime picker overrides
	::v-deep .vdatetime {
		&-calendar {
			margin-bottom: -1rem;
		}
		&-popup__actions {
			padding-top: 10px;
			&__button:not(:hover) {
				color: $col-primary;
			}
		}
		&-month-picker__item--selected,
		&-year-picker__item--selected,
		&-time-picker__item--selected {
			color: $col-primary-dark;
		}
		&-popup__header,
		&-calendar__month__day--selected > span > span {
			background-color: $col-primary;
		}
	}
}
</style>
